import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QuotaService {
  showModal = signal(false);
  modalMessage = signal('');

  openQuotaModal(message?: string) {
    if (message) {
      this.modalMessage.set(message);
    } else {
      this.modalMessage.set('You have reached the limit for this action on your current plan. Please wait for your monthly reset or upgrade your plan to continue.');
    }
    this.showModal.set(true);
  }

  closeModal() {
    this.showModal.set(false);
  }
}
